module.exports = __webpack_public_path__ + "static/media/bg-works.823343e1.png";